import { api } from '@/services/api/main/axios';

export interface LoginSupportForm {
  userId: string;
  password: string;
  recaptchaResponse: string;
}

export const loginSupportApiRequest = async (form: LoginSupportForm) => {
  return api.post('auth/login/support', form);
};
